import React, { FC } from "react";
import { SingleFilter } from "./singleFilter";
import { getFilterProps } from "./helper";
import { INTERNAL_STATUS_OPTIONS } from "../../../videoProduction/helper";
import { IconClock } from "../../../../utils/icons";

const INTERNAL_STATUS_FILTERS = INTERNAL_STATUS_OPTIONS.map(({ value, label }) => ({
  id: value,
  name: label,
}));

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryFilters?: any;
}

export const InternalStatusFilter: FC<Props> = ({ onFilterSelect, ...rest }) => (
  <SingleFilter
    {...rest}
    {...getFilterProps(INTERNAL_STATUS_FILTERS, "internalStatus", "Internal Status")}
    icon={IconClock}
    updateSearch={onFilterSelect}
  />
);
